import React, { ReactNode } from "react";

// components
import FaqItem from "./FaqItem";
import { Container } from "@/shared/components/Container";
import { Accordion } from "@/shared/components/ui/accordion";
import { Heading } from "@/shared/components/ui/Heading";

// utils
import { cn } from "@/shared/utils";

interface FaqModuleProps {
    className?: string;
    faqs?: { question: string; answer: ReactNode }[];
}

const FaqModule: React.FC<FaqModuleProps> = ({ className, faqs }) => {
    return (
        <Container className={cn("mx-auto flex flex-col gap-2 py-8 xl:py-8", className)}>
            <div className="mx-2 flex flex-col gap-2 text-center text-content-primary">
                <Heading level="h2" className="text-xl font-medium">
                    Frequently Asked Questions
                </Heading>
                <p className="text-sm text-content-secondary">{"Have questions about pet insurance and how it works? Don't worry, we've got you covered."}</p>
            </div>
            <div className="mx-auto w-full max-w-[720px]">
                <Accordion type="single" defaultValue="item-1" collapsible>
                    {faqs?.map((faq, index) => <FaqItem key={index} question={faq.question} answer={faq.answer} />)}
                </Accordion>
            </div>
        </Container>
    );
};

export default FaqModule;
